import { render } from "./DashboardCard.vue?vue&type=template&id=25fa209a&scoped=true"
import script from "./DashboardCard.vue?vue&type=script&lang=js"
export * from "./DashboardCard.vue?vue&type=script&lang=js"

import "./DashboardCard.vue?vue&type=style&index=0&id=25fa209a&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25fa209a"]])

export default __exports__